import { styled, TextField } from '@mui/material'
import { spacingOne } from 'utility/spacings'

export const AddNoteInputStyled = styled(TextField)({
  width: '100%',
  marginTop: spacingOne
})
